import { formatNumber } from '@angular/common';
import { Component, OnDestroy, OnInit, Input, ChangeDetectorRef, output } from '@angular/core';
import { BreakpointObserver, Breakpoints } from '@angular/cdk/layout';
import { MatDialog } from '@angular/material/dialog';
import { TvangebotimagevideoComponent } from '@app/components/modals/tvangebotimagevideo/tvangebotimagevideo.component';
import { CruiseBooking } from '@app/models/kreuzfahrts/CruiseBooking';
import { CruiseCabin } from '@app/models/kreuzfahrts/CruiseCabin';
import { CruiseCatalog } from '@app/models/kreuzfahrts/CruiseCatalog';
import { CruiseOfferCabin } from '@app/models/kreuzfahrts/CruiseOfferCabin';
import { PackageCab } from '@app/models/kreuzfahrts/PackageCab';
import { Partner } from '@app/models/partner/IPartner';
import { AuthGuardService } from '@app/services/auth-guard.service';
import { CruiseService } from '@app/services/cruise.service';
import moment from 'moment';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';

@Component({
    selector: 'clever-cruis-detail',
    templateUrl: './cruis-detail.component.html',
    styleUrls: ['./cruis-detail.component.scss'],
    standalone: false
})
export class CruisDetailComponent implements OnInit, OnDestroy {
    @Input() booking: CruiseBooking;
    @Input() cabin: CruiseOfferCabin;
    @Input() catalog: CruiseCatalog;
    readonly sendAlt = output<any>();
    readonly sendBook = output<any>();
    deskMode: boolean = true;
    travelerText: string = '';
    desktopTemplate: string = 'xl';
    prcdetail: string = '';
    currentCabin: CruiseCabin;
    package: PackageCab;
    currentTab:number = 1;
    currentpartner: Partner;
    private unsubscribe$ = new Subject();

    constructor(
        protected mediaObserver: BreakpointObserver,
        private cdr: ChangeDetectorRef,
        protected cruiseService: CruiseService,
        private dialog: MatDialog,
         protected guardService: AuthGuardService,
    ) {}

    ngOnInit(): void {
        // console.log(this.booking);
        // console.log(this.cabin);
        // console.log(this.catalog);
        this.initPrcData();
        this.initdatas();
        this.initCabin();
        this.initPartner();
        this.initMedia();
    }

    async initPartner() {
        this.guardService.getPartner$.pipe(
            takeUntil(this.unsubscribe$)
        ).subscribe((partner) => {
            this.currentpartner = partner;
            if (this.currentpartner?.partnerid?.length > 0) {
                if (this.cabin.hotel?.giataid > 0) {
                    this.getpackage();
                }
            }
            // this.prufen();
            this.cdr.detectChanges();
        });
    }

    async initMedia() {
        if (this.mediaObserver.isMatched(Breakpoints.XSmall)) {
            this.desktopTemplate = 'xs';
            this.deskMode = false;
        }
        if (this.mediaObserver.isMatched(Breakpoints.Small)) {
            this.desktopTemplate = 'sm';
            this.deskMode = false;
        }
        if (this.mediaObserver.isMatched(Breakpoints.Medium)) {
            this.desktopTemplate = 'md';
            this.deskMode = true;
        }
        if (this.mediaObserver.isMatched(Breakpoints.Large)) {
            this.desktopTemplate = 'lg';
            this.deskMode = true;
        }
        if (this.mediaObserver.isMatched(Breakpoints.XLarge)) {
            this.desktopTemplate = 'xl';
            this.deskMode = true;
        }
        this.cdr.detectChanges();
    }

    async initPrcData() {
        let countEr = 1;
        let kind = 0;
        let erw = 0;
        for (let i = 0; i < this.booking?.pricedetails?.travellers?.length; i++) {
            let prc = '';
            if (this.booking.pricedetails.travellers[i].total > 0) {
                prc = formatNumber(Number(this.booking.pricedetails.travellers[i].total), 'de-DE', '1.2-2');
            } else {
                prc = formatNumber(Number(this.booking.pricedetails.travellers[i].total), 'de-DE', '1.2-2');
            }
            if (prc?.length > 0) {
                if (this.booking.pricedetails.travellers[i].title === 'H') {
                    this.prcdetail += countEr + '.Erwachsener ' + prc + ' EUR<br>';
                    countEr++;
                    erw += 1;
                } else {
                    this.prcdetail += countEr + '.Kinder ' + prc + ' EUR<br>';
                    countEr++;
                    kind += 1;
                }
            }
        }
        if (erw > 0) {
            this.travelerText = erw + ' Erwachsene';
        }
        if (kind > 0) {
            this.travelerText += ', ' + kind + ' Kinder';
        }
        this.cdr.detectChanges();
    }

    async initCabin() {
        // curentCabin
        for (let i = 0; i < this.catalog?.cabins.length; i++) {
            if (this.catalog?.cabins[i].cabin_code === this.cabin.kabinen_code) {
                this.currentCabin = this.catalog?.cabins[i];
                i = this.catalog?.cabins.length;
            }
        }
        this.cdr.detectChanges();
    }

    async initdatas() {
        for (let i = 0; i < this.catalog.routing?.length; i++) {
            this.catalog.routing[i].date = moment(this.catalog?.schedule?.[0]?.cruise_start_date).add(Number(this.catalog.routing[i].day) - 1, 'days').format('YYYY-MM-DD');
        }
        this.cdr.detectChanges();
    }

    ngOnDestroy(): void {
        this.unsubscribe$.next(true);
        this.unsubscribe$.complete();
    }

    sendAalternative() {
        this.sendAlt.emit(true);
    }

    sendBooking() {
        this.sendBook.emit(true);
    }

    getpackage(): void {
        if (this.cabin.oid?.length > 0 && this.currentpartner?.partnerid?.length > 0) {
            this.cdr.detectChanges();
            const target = {
                ref: this.currentpartner?.xt?.ref,
                giataid: this.cabin.hotel.giataid,
                provider: this.cabin.hotel_provider,
                partnerid: this.currentpartner?.partnerid
            };
            this.cruiseService.request(target, 'packagedatas').pipe(
                takeUntil(this.unsubscribe$)
            ).subscribe((res) => {
                this.package = res?.data;
                this.cdr.detectChanges();
            });
        }
    }

    async openImageModal(ev) {
        const target = {
            disableClose: true,
            panelClass: ['full-screen-modal'],
            data: {
                hotel: this.package,
                images: this.package.images,
                videos: [],
                current: ev,
                to800: true,
                desktopTemplate: this.desktopTemplate
            }
        }
        this.dialog.open(TvangebotimagevideoComponent, target);
    }
}
